export default __webpack_public_path__ + "static/media/zukunf_lauft_background_m1.a686e86c.jpg";